import {
    Container,
    Card,
    CardContent,
    Grid,
    TextField,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Skeleton,
    CircularProgress,
    Box,
    Typography,
} from "@mui/material";
import { DisplayCompaniesList } from "../CompanyProfilePage/DisplayCompaniesList";
import React, { useEffect, useState } from "react";
import { getUserList, getCompanyProfileList, getRoles, AddUserPost, EditUserPost, DeleteUserApi, getAllCompanyProfileList, getAllUserList } from "./helper";
import CSDataTable from "../../components/CSDataTable";
import { CSDataTableColumns } from "../../modal/CSDataTable";
import { AddUser, EditUser, RoleList, UserList, DeleteUser } from "./modal";
import { useUserContext } from "../../context/auth/UserContext";
import { companyList } from "../CompanyProfilePage/modal";
import { Role } from "../../modal/UserAccess";
import DialogBoxComponent from "../../components/DialogBoxComponent";
import { useMediaQuery, useTheme } from "@mui/material";
import AuthContext from "../../context/auth/AuthContext";
import { getUserAccess } from "../../helper/helper_userAccess";
import { useAccessRights } from "../../utils/useAccessRights";

const getFieldControlStyles = () => ({
    backgroundColor: "#F1F5F7",
    width: "90%",
    ".MuiOutlinedInput-root": {
        border: "none",
        "& fieldset": {
            border: "none",
        },
    },
    borderRadius: "5px",
});



interface FormValues {
    userName: string;
    emailId: string;
    client: number | null;  // Accept number or null
    role: number | null;    // Accept number or null
}

let initialFormState = {
    userName: "",
    emailId: "",
    client: null as number | null,  // Accept number or null
    role: null as number | null,    // Accept number or null
}
export const UserRoleSetup = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const userRoleSetUpPermission = useAccessRights("User Role SetUp")

    const { userId, companyProfileID, userAccess, setUserAccess } = useUserContext();
    const authContext = React.useContext(AuthContext);
    const { portalUser } = authContext;

    const [userList, setUserList] = useState<UserList[]>([]);
    const [clientList, setClientList] = useState<companyList[]>([]);
    const [roleList, setRoleList] = useState<RoleList[]>([]);
    const [selectedUser, setSelectedUser] = useState<UserList | null>(null);
    const [formValues, setFormValues] = useState<FormValues>(initialFormState);
    const [isEditMode, setIsEditMode] = useState(false)
    const [isFormLoading, setIsFormLoading] = useState(false)
    const [isTableLoding, setIsTableLoading] = useState(false)
    const [emailError, setEmailError] = useState("");


    const [dialogState, setDialogState] = useState({
        title: "",
        body: "",
        action: "",
        actionCancel: "",
        openDeleteConfirmation: false,
        openSuccessDialogBox: false,
    });
    const hasPermission = () => {
        return isEditMode ? userRoleSetUpPermission?.isCreate : userRoleSetUpPermission?.isUpdate
    }
    const columns: CSDataTableColumns[] = [
        {
            accessorKey: "userName",
            header: "User Name",
            size: "70px",
            enableColumnFilter: true,
        },
        {
            accessorKey: "userEmail",
            header: "Email Id",
            size: "90px",
            enableColumnFilter: true,
        },
        {
            accessorKey: "companyName",
            header: "Client Name",
            size: "60px",
            enableColumnFilter: true,

        },
        {
            accessorKey: "roleName",
            header: "Role Name",
            size: "40px",
            filterVariant: "select",
            filterSelectOptions: roleList.map(item => item.roleName),
            enableColumnFilter: true,

        },
        {
            accessorKey: "edit",
            header: "",
            size: "5px",
            isEditable: userRoleSetUpPermission?.isUpdate,
            enableColumnFilter: false,
        },
        {
            accessorKey: "delete",
            header: "",
            size: "5px",
            isDeletable: userRoleSetUpPermission?.isUpdate,
            enableColumnFilter: false,
            disableDeleteCondition: (e: UserList) => e.userEmail === userAccess.userInformation.userEmail && e.companyProfileID === companyProfileID, // Corrected condition
        },
    ];

    const fetchCompaniesList = async () => {
        let companyRes = null
        if (userAccess.roles[0].roleName === "JSIAdmin" || userAccess.roles[0].roleName === "JSIUser") {
            companyRes = await getAllCompanyProfileList()
        } else {
            companyRes = await getCompanyProfileList(userId)
        }
        fetchUserList(companyRes)
        setClientList(companyRes);
    };

    const fetchRole = async () => {
        const res = await getRoles();
        if (userAccess.roles[0].roleName === "ClientAdmin") {
            //JSI Roles should dot display in dropdown if ClientAdmin logged in  
            const filtClientRoles = res.filter((role: RoleList) => {
                return !role.roleName.toLocaleLowerCase().startsWith("jsi")
            })
            setRoleList(filtClientRoles);
        } else {
            setRoleList(res)
        }

    };

    const fetchUserList = async (companyRes?: companyList[] | null) => {
        setIsTableLoading(true);
        try {
            // Check if companyRes exists, else use clientList
            const companyProfileIds = (companyRes ? companyRes : clientList)
                .map(item => item.companyProfileID)
                .join(",");
            const res = await getUserList(companyProfileIds);
            let formattedList: UserList[] = res.map((user: UserList) => ({
                ...user,
                rowId: user.userID,
            }));
            formattedList = formattedList.sort((a, b) => {
                const getRelevantDate = (item: UserList) => {
                    if (!item.updateDate) {
                        return new Date(item.createDate);
                    }
                    return new Date(item.updateDate) > new Date(item.createDate) ? new Date(item.updateDate) : new Date(item.createDate);
                };

                const aDate = getRelevantDate(a);
                const bDate = getRelevantDate(b);

                return bDate.getTime() - aDate.getTime(); // Sort in descending order to get latest date first
            });


            console.log("userAccess", userAccess);
            if (userAccess.roles[0].roleName.startsWith("Client")) {
                const filtUserList = formattedList.filter(item => !item.roleName.startsWith("JSI"))
                setUserList(filtUserList);
            } else {
                setUserList(formattedList);
            }
        } finally {
            setIsTableLoading(false);
        }
    };
    const fetchAllUserList = async () => {
        setIsFormLoading(true)
        const res = await getAllUserList();
        return res
    };

    const handleAllApi = async () => {
        setIsFormLoading(true);
        setIsTableLoading(true);
        try {
            // Wait for all API calls to complete using Promise.all
            await Promise.all([fetchRole(), fetchCompaniesList()]);
        } catch (error) {
            console.error("Error in one of the API calls", error);
        } finally {
            setIsFormLoading(false); // Stop loading after all API calls are completed
        }
    };



    const handleInputChange = (event: any) => {
        const { name, value } = event.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };


    const handleEdit = (row: UserList) => {
        setIsEditMode(true);
        setSelectedUser(row); // Set the selected user's ID

        // Populate the form fields with the selected user's data
        setFormValues({
            userName: row.userName,
            emailId: row.userEmail,
            client: row.companyProfileID,
            role: row.roleID,
        });
    };


    const handleDeleteClick = (row: UserList) => {
        setSelectedUser(row)
        setDialogState({
            title: "Confirm",
            body: `Are you sure you want to delete <strong>${row?.userName}</strong>.?`,
            action: "Delete",
            actionCancel: "Cancel",
            openDeleteConfirmation: true,
            openSuccessDialogBox: false,
        });

    }
    const handleDeleteConfirm = async () => {
        setDialogState({
            ...dialogState,
            openDeleteConfirmation: false,
            openSuccessDialogBox: false,
        });
        setIsTableLoading(true)
        try {
            const date = new Date();
            const payload: DeleteUser = {
                userID: selectedUser?.userID || 0,
                updateDate: date,
                updateBy: userId,
                isDeleted: true,
                companyProfileID: selectedUser?.companyProfileID || 0
            }
            const res = await DeleteUserApi(payload)

            if (res.succeeded) {
                setDialogState({
                    title: "Success",
                    body: `<strong>${selectedUser?.userName}</strong> successfully deleted`,
                    action: "OK",
                    actionCancel: "",
                    openDeleteConfirmation: false,
                    openSuccessDialogBox: true,
                });
                setSelectedUser(null);
                fetchUserList()
            } else {
                setDialogState({
                    title: "Error",
                    body: `Unexpected Error while deleting <strong>${selectedUser?.userName}</strong>`,
                    action: "OK",
                    actionCancel: "",
                    openDeleteConfirmation: false,
                    openSuccessDialogBox: true,
                });
                setSelectedUser(null);
            }
        } finally {
            setIsTableLoading(false)
        }

    }

    const refreshUserAccess = async () => {
        //Refreshing useraccess in local storage
        localStorage.removeItem("userAccess");
        try {
            if (portalUser?.email) {
                const res = await getUserAccess(portalUser.email);
                setUserAccess(res);
                localStorage.setItem("userAccess", JSON.stringify(res));
            }
        } catch (err) {
            console.error("err", err);

        }
    }

    const handleSubmit = async () => {

        // Regular expression to validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // Check if the emailId is valid
        if (!emailRegex.test(formValues.emailId)) {
            setEmailError("Please enter a valid email address.");
            return;  // Stop the form submission if email is invalid
        } else {
            setEmailError("");  // Clear error if email is valid
        }
        const resAllUserList: UserList[] = await fetchAllUserList()
        const filt = resAllUserList.filter(item => item.userEmail === formValues.emailId)
        if ((isEditMode && filt.length > 1) || (!isEditMode && filt.length > 0)) {
            const isSameRole = filt.every(item => item.roleID === formValues.role);
            if (!isSameRole) {
                setDialogState({
                    title: "Info",
                    body: `<strong>${formValues.userName}</strong> has already assigned <strong>${filt[0].roleName}</strong> role. You cannot assign a different role to this user.Please assign same role.`,
                    action: "OK",
                    actionCancel: "",
                    openDeleteConfirmation: false,
                    openSuccessDialogBox: true,
                });
                setIsFormLoading(false)
                return
            }
        }
        try {
            setIsTableLoading(true)
            const date = new Date();
            let res = null
            if (isEditMode) {
                const payload: EditUser = {
                    userID: selectedUser?.userID || 0,
                    userName: formValues.userName,
                    userEmail: formValues.emailId,
                    updateDate: date,
                    updateBy: userId,
                    companyProfileID: formValues.client || 0,
                    roleID: formValues.role || 0
                };
                res = await EditUserPost(payload)
                if (res.succeeded && selectedUser?.userID == userId) {
                    refreshUserAccess()
                }

            } else {
                const payload: AddUser = {
                    userName: formValues.userName,
                    userEmail: formValues.emailId,
                    createDate: date,
                    createdBy: userId,
                    companyProfileID: formValues.client || 0,
                    roleID: formValues.role || 0
                };
                res = await AddUserPost(payload)

            }
            if (res.succeeded) {
                setDialogState({
                    title: "Success",
                    body: isEditMode ? "User Successfully Updated" : "User Successfully Created",
                    action: "OK",
                    actionCancel: "",
                    openDeleteConfirmation: false,
                    openSuccessDialogBox: true,
                });
                setSelectedUser(null);
                setIsEditMode(false);
                setFormValues(initialFormState);
                fetchUserList()
                handleReset()
            } else {
                setDialogState({
                    title: "Info",
                    body: `${res.message}`,
                    action: "OK",
                    actionCancel: "",
                    openDeleteConfirmation: false,
                    openSuccessDialogBox: true,
                });
            }
        } catch (error) {
            console.error(error);

        } finally {
            setIsTableLoading(false)
            setIsFormLoading(false)
        }
    };





    const isDisabled = () => {
        // Assuming `selectedUser` is an object with user properties from the row you're editing

        // Check if all form values are filled (i.e., not empty or null)
        const areFormValuesFilled =
            formValues.userName &&
            formValues.emailId &&
            formValues.client &&
            formValues.role;

        if (isEditMode && selectedUser) {
            // If form values are not filled, disable the button
            if (!areFormValuesFilled) {
                return true;
            }

            // Check if all form values match the selectedUser values
            const isMatching =
                formValues.userName === selectedUser.userName &&
                formValues.emailId === selectedUser.userEmail &&
                formValues.client === selectedUser.companyProfileID &&
                formValues.role === selectedUser.roleID;

            // If all fields match, disable the button (no changes made)
            return isMatching;
        } else {
            // In create mode, check if all fields are filled
            return !areFormValuesFilled;  // Disable the button if any field is empty
        }
    };


    const handleCloseDialog = () => {
        if (dialogState.title !== "Error") {
            setDialogState({
                ...dialogState,
                openDeleteConfirmation: false,
                openSuccessDialogBox: false,
            });
        } else {
            setDialogState({
                ...dialogState,
                openDeleteConfirmation: false,
                openSuccessDialogBox: false,
            });
        }
    };

    const handleReset = () => {
        setFormValues(initialFormState)
        setSelectedUser(null)
        setIsEditMode(false)
    }


    useEffect(() => {
        if (emailError) {
            setEmailError("")
        }
    }, [formValues.emailId])

    useEffect(() => {
        handleAllApi();

    }, []);



    return (
        <React.Fragment>
            <Card
                sx={{
                    width: "100%",
                    height: "95%",
                    borderRadius: "10px",
                    margin: "1rem 0",
                    overflow: "hidden",
                }}
            >
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: "left" }}>
                            <Typography
                                sx={{
                                    textTransform: 'uppercase',
                                    opacity: 0.7,
                                    fontSize: "1rem"
                                }}

                            >
                                {isEditMode ? "Update User" : "Create User"}
                            </Typography>
                        </Grid>
                        <Grid item xs={isSmallScreen ? 12 : 6}>
                            {isFormLoading ? (
                                <Skeleton variant="rectangular" sx={getFieldControlStyles} height={40} />
                            ) : (
                                <TextField
                                    autoFocus
                                    sx={getFieldControlStyles}
                                    label="User Name"
                                    name="userName"
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    value={formValues.userName}
                                    onChange={handleInputChange}
                                    disabled={!hasPermission()}
                                />
                            )}
                        </Grid>
                        <Grid item xs={isSmallScreen ? 12 : 6}>
                            {isFormLoading ? (
                                <Skeleton variant="rectangular" sx={getFieldControlStyles} height={40} />
                            ) : (
                                <TextField
                                    sx={getFieldControlStyles}
                                    label="Email Id"
                                    name="emailId"
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    value={formValues.emailId}
                                    onChange={handleInputChange}
                                    error={!!emailError} // Set error state
                                    helperText={emailError} // Display error message
                                    disabled={!hasPermission()}
                                />
                            )}
                        </Grid>
                        <Grid item xs={isSmallScreen ? 12 : 6}>
                            {isFormLoading ? (
                                <Skeleton variant="rectangular" sx={getFieldControlStyles} height={40} />
                            ) : (
                                <FormControl disabled={!hasPermission() || isEditMode} fullWidth size="small" sx={getFieldControlStyles}>
                                    <InputLabel
                                        id="client-name-label"
                                        shrink={!!formValues.client}
                                    >
                                        Client Name
                                    </InputLabel>
                                    <Select
                                        labelId="client-name-label"
                                        label="Client Name"
                                        name="client"
                                        value={formValues.client}
                                        onChange={handleInputChange}
                                        variant="outlined"

                                    >
                                        {clientList.map((client) => (
                                            <MenuItem key={client.companyProfileID} value={client.companyProfileID}>
                                                {client.companyName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )}
                        </Grid>
                        <Grid item xs={isSmallScreen ? 12 : 6}>
                            {isFormLoading ? (
                                <Skeleton variant="rectangular" sx={getFieldControlStyles} height={40} />
                            ) : (
                                <FormControl disabled={!hasPermission()} fullWidth size="small" sx={getFieldControlStyles}>
                                    <InputLabel
                                        id="role-name-label"
                                        shrink={!!formValues.role}
                                    >
                                        Role Name
                                    </InputLabel>
                                    <Select
                                        labelId="role-name-label"
                                        label="Role Name"
                                        name="role"
                                        value={formValues.role}
                                        onChange={handleInputChange}
                                        variant="outlined"
                                    >
                                        {roleList.map((role: RoleList) => (
                                            <MenuItem key={role.roleID} value={role.roleID}>
                                                {role.roleName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )}
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>

                            <Button aria-label="Reset Form" variant="outlined" size="small" sx={{
                                marginRight: '1rem', backgroundColor: "rgba(0, 102, 255, 0.1)",
                                color: "#0066FF",
                                '&:hover': {
                                    bgcolor: "#0066ff2e",
                                },
                                border: "none"
                            }}
                                disabled={isFormLoading || isTableLoding || !hasPermission()}
                                onClick={handleReset} >
                                Reset
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={handleSubmit}
                                disabled={isDisabled() || isFormLoading || isTableLoding || !hasPermission()}
                                aria-label={isEditMode ? "Update User" : "Create User"}
                                sx={{
                                    backgroundColor: "#0066FF",
                                    '&:hover': {
                                        bgcolor: "#0556d0",
                                    },
                                    border: "none"
                                }}

                            >
                                {isEditMode ? "Update" : "Create"}
                            </Button>

                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            {isTableLoding ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "100%",
                                    }}
                                >
                                    <CircularProgress />
                                </Box>
                            ) : (
                                <CSDataTable
                                    rows={userList}
                                    columns={columns}
                                    multiRowSelection={false}
                                    handleEdit={handleEdit}
                                    handleDelete={handleDeleteClick}
                                    enableRowSelection={false}
                                    enableColumnFilter={true}
                                />
                            )}
                        </Grid>
                    </Grid>

                </CardContent>
            </Card>
            {/* //Confirmation */}
            {
                <DialogBoxComponent
                    openDialogBox={dialogState.openDeleteConfirmation}
                    dialogTitle={dialogState.title}
                    dialogAction={dialogState.action}
                    dialogActionCancel={dialogState.actionCancel}
                    dialogBody={dialogState.body}
                    handleFunction={handleDeleteConfirm}
                    handleCancel={handleCloseDialog}
                />
            }
            {
                //success
                <DialogBoxComponent
                    openDialogBox={dialogState.openSuccessDialogBox}
                    dialogTitle={dialogState.title}
                    dialogAction={dialogState.action}
                    dialogBody={dialogState.body}
                    handleFunction={handleCloseDialog}
                />
            }
        </React.Fragment >
    );
};
